import script from "./EstadoTurno.vue?vue&type=script&setup=true&lang=js"
export * from "./EstadoTurno.vue?vue&type=script&setup=true&lang=js"

import "./EstadoTurno.vue?vue&type=style&index=0&id=d03c40f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d03c40f6"]])

export default __exports__